export enum ActionName {
  Approve = 'Approve',
  Decline = 'Decline',
  Pending = 'Pending',
  PendingOrg = 'Pending - org',
  ForcibleApprove = 'Forcible approve',
  ForcibleDecline = 'Forcible decline',
  ForciblePending = 'Forcible pending',
  EscalateTask = 'Escalate task',
  EscalateTaskCluster = 'Escalate task cluster',
  Archive = 'archive',
  Claim = 'Claim',
  ClaimWithoutCreatingComments = 'Claim without creating comments',
  UnassignAll = 'unassignAll',
  Unassign = 'Unassign',
  Assign = 'Assign',
  SetMoneyOut = 'Set Money-out (ODE)',
  ManageODE = 'Manage ODE',
  SetMoneyIn = 'Set Money-in (KYB)',
  EscalateToPops = 'Escalate to pops',
  UpdateLegalInfo = 'Update legal info',
  RunOde = 'Run ODE',
  RunOdeStrategy = 'Run ODE Strategy',
  SetManualCrr = 'Set Manual CRR',
  RunAutoCrr = 'Run Auto CRR',
  AddNewProject = 'Add new project',
  RemoveProject = 'Remove project',
  ArchiveProject = 'Archive project',
  ViewProject = 'View project',
  ViewAndEditProject = 'View and edit project',
  ManageTags = 'Manage tags',
  AddSanctionsDecision = 'Add sanction screening decision',
  SendUserCommunication = 'Send user communication',
  ChangeEmail = 'Change email',
  ChangeDateOfBirth = 'Change date of birth',
  Reject = 'Reject',
  SetMicroDepositEligibility = 'Set Micro Deposit Eligibility',
  ConvertIntoTask = 'Convert into task',
  MergeToSimilarBusinessBusyTask = 'Merge to similar business busy task',
  CreateNewBusinessBusyTask = 'Create new business busy task',
  RejectBusyTask = 'Reject busy task',
  EscalateBusyTask = 'Escalate busy task',
  UnassignBusyTasks = 'Unassign busy tasks',
  AssignBusyTasks = 'Assign busy tasks',
  PaymentNotes = 'Payment notes',
  PaymentTags = 'Payment tags',
  ArchiveEscalation = 'Archive escalation',
  ReactivateEscalationFromThread = 'Reactivate escalation from thread',
  ConvertIntoTaskAndEscalate = 'Convert into task and escalate',
  ConvertIntoTaskAndEscalateDeletedPayment = 'Convert to task and escalate (deleted payment)',
  AttachFile = 'Attach file',
  ManageFileMetadata = 'Manage file metadata',
  EditLegalInfoKyc = 'Edit legal info kyc',
  RequestForInformation = 'Request for information',
  RequestForInformationForOrg = 'Request for information - org',
  RequestForInformationCluster = 'Request for information cluster',
  EditIdmVerificationKyc = 'Edit idm verification kyc',
  EditUboData = 'Edit Ubo Data',
  DeleteUboData = 'Delete Ubo Data',
  NewUboData = 'Add New Ubo Data',
  RunOrgRiskAnalyzer = 'Run risk analyzer - org',
  setNoUbosDeclarationForOrg = 'Set Ubos Declaration For Org',
  SetCsomProfile = 'Set CSOM profile',
  LinkOKIDocuments = 'Link OKI Documents',
  RefreshLabelAndConcernAreas = 'Refresh Label and Concern areas',
  ManageOrgLimitations = 'Manage org limitations',
  ManageUserLimitations = 'Manage user limitations',
  AddTaxVerification = 'Add tax verification',
  EditTaxVerification = 'Edit tax verification',
  SubmitFraudReferralDecision = 'Submit fraud referral decision',
  EditFraudReferralAlertDate = 'Edit fraud referral alert date',
  RerunCdd = 'Re-run CDD',
  Recollect = 'Recollect',
  AchReversal = 'ACH Reversal',
  RunRiskAnalyzer = 'Run risk analyzer',
  ConfirmAtoAutomationCaseAsComplete = 'Confirm as complete',
  PostAtoAutomationCase = 'Post the case',
  AtoAutomationCaseSummary = 'Case summary',
  CreateTagDefinition = 'Create tag definition',
  EditTagDefinition = 'Edit tag definition',
  RemoveTagDefinition = 'Remove tag definition'
}
